import { render } from "./ChoiceQuiz.vue?vue&type=template&id=7c76893c&scoped=true"
import script from "./ChoiceQuiz.vue?vue&type=script&lang=js"
export * from "./ChoiceQuiz.vue?vue&type=script&lang=js"

import "./ChoiceQuiz.vue?vue&type=style&index=0&id=7c76893c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c76893c"]])

export default __exports__